import { createApp } from 'vue'
import i18n from 'src/lang/index.js'
import Login from './Login.vue'
import ResetPassword from './ResetPassword.vue'
import Landing from './Landing.vue'

const mountApp = (selector, RootComponent) => {
  const el = document.querySelector(selector)
  if (!el) return

  const app = createApp(RootComponent)
  app.use(i18n)
  app.mount(selector)
}

mountApp('#login-app', Login)
mountApp('#reset-app', ResetPassword)
mountApp('#landing-app', Landing)


